import React, { Component, useRef, useState } from "react";
import {
    DataGrid,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
    Lookup as dxLookup
} from "devextreme-react/data-grid";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button, Lookup } from "devextreme-react";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarParametrosPixDs } from "../../DataSources";

const ParametrosPixBox = (props) => {

    const { onSelecionado, usadoComoPesquisa } = props;
    let _gridInstance = useRef();
    let _formInstance = useRef();

    const dadosFiltroPadrao = { id: undefined, nome: "", fornecedorPix: 0, nomeChave: "", convenio: "" };

    const [filtroState, setFiltroState] = useState(dadosFiltroPadrao);

    const dataSource = criarParametrosPixDs();


    const statusOptions = {
        editorType: "dxSelectBox",
        searchEnabled: true,
        placeholder: "Escolher...",
        dataSource: [
            { id: 0, descricao: "TODOS" },
            { id: 1, descricao: "BANCO DO BRASIL" },
            { id: 104, descricao: "CAIXA" },
        ],
        valueExpr: "id",
        displayExpr: "descricao",
    };



    const onAtualizandoRow = (e) => {
        e.cancel = true;
        props.history.push("parametros_pix/editar/" + e.data.id);
    }

    const filtrar = (e) => {
        let filtro = filtroState;

        let filtroCorrente = [];

        if (
            filtro.id !== undefined &&
            filtro.id !== "" &&
            filtro.id !== null
        ) {
            filtroCorrente.push(["id", "=", filtro.id]);
        }
        if (filtro.nomeChave !== undefined && filtro.nomeChave !== "") {
            filtroCorrente.push(["nomeChave", "contains", filtro.nomeChave.trim()]);
        }
        if (filtro.convenio !== undefined && filtro.convenio !== "") {
            filtroCorrente.push(["convenio", "contains", filtro.convenio.trim()]);
        }
        if (filtro.fornecedorPix !== undefined && filtro.fornecedorPix !== 0) {
            filtroCorrente.push(["fornecedorPix", "=", filtro.fornecedorPix]);
        }

        if (_gridInstance && _gridInstance.instance) {
            _gridInstance.instance.filter(
                filtroCorrente.length > 0 ? filtroCorrente : null
            );
        }

    }

    const limparFiltro = () => {
        setFiltroState({ ...dadosFiltroPadrao });
        filtrar();

        if (_formInstance && _formInstance.instance) {
            _formInstance.instance.repaint();
        }

        console.log("limpar filtro");
    }

    const novaEntidade = () => {
        props.history.push("parametros_pix/novo");
    }

    return (
        <React.Fragment>
            <div className={"content-block dx-card responsive-paddings"}>
                <form onSubmit={filtrar}>
                    <Form id="frmPesquisa" formData={filtroState} colCount={10}
                        ref={(e) => (_formInstance = e)}>
                        <SimpleItem
                            dataField="id"
                            editorType={"dxNumberBox"}
                            colSpan={2}
                            editorOptions={{ step: 0, value: null }}
                        >
                            <Label text="Código" />
                        </SimpleItem>
                        <SimpleItem dataField="nomeChave" colSpan={3}>
                            <Label text="Nome" />
                        </SimpleItem>
                        <SimpleItem
                            dataField="fornecedorPix"
                            colSpan={3}
                            editorType={"dxSelectBox"}
                            editorOptions={statusOptions}
                        >
                            <Label text="Banco" />
                        </SimpleItem>
                        
                        <SimpleItem dataField="convenio" colSpan={2}>
                            <Label text="Convênio" />
                        </SimpleItem>
                    </Form>
                    <br />
                    <div style={{ marginTop: "10px" }}>
                        <div style={{ display: "inline-block" }}>
                            <Button
                                width={120}
                                text="Filtrar"
                                type="success"
                                onClick={filtrar}
                            />
                        </div>
                        <div style={{ display: "inline-block", marginLeft: "10px" }}>
                            <Button text="Limpar Filtro" onClick={limparFiltro} />
                        </div>
                    </div>
                </form>
                <br /> <br />
                <PaginaToolbar
                    titulo="Parâmetros Pix"
                    novoCb={novaEntidade}
                >
                    <DataGrid
                        ref={(grid) => (_gridInstance = grid)}
                        dataSource={dataSource}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        columnAutoWidth={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={window.innerWidth < 800}
                        filterSyncEnabled={true}
                        onEditingStart={onAtualizandoRow}
                    >
                        <Editing
                            allowDeleting={!usadoComoPesquisa}
                            allowUpdating={!usadoComoPesquisa}
                            useIcons={true}
                            visible={!usadoComoPesquisa}
                        />

                        <Column
                            type="buttons"
                            fixed={true}
                            fixedPosition={"left"}
                            buttons={[
                                "edit",
                                "delete",
                                {
                                    hint: "Selecionar",
                                    icon: "repeat",
                                    visible: usadoComoPesquisa != undefined,
                                    onClick: onSelecionado,
                                },

                            ]}
                        />
                        <Column
                            dataField={"id"}
                            visibleIndex={1}
                            allowEditing={false}
                            caption={"#"}
                            width={80}
                        />

                        <Column
                            dataField={"prefeituraId"}
                            caption={"Prefeitura"}
                            visible={false}
                        >
                            <FormItem visible={false}></FormItem>
                        </Column>
                        <Column dataField={"nomeChave"} caption={"Nome"} />
                        <Column dataField={"fornecedorPixStr"} caption={"Banco"} allowSorting={false} />
                        <Column dataField={"chavePadrao"} caption={"Padrão"} />
                        <Column dataField={"convenio"} caption={"Convênio"} />
                        <Column dataField={"chavePix"} caption={"Chave PIX"} />

                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

                        <Pager
                            showInfo={true}
                            showNavigationButtons={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        </React.Fragment>
    );

}

export default ParametrosPixBox;

